<!-- Total cost -->
<div class="form-group">
  <div class="total-block">
    <div class="total-block__text">
      <h3>{{ "product.receipt.label.total" | translate }}</h3>
      <span>{{ ("payment.receipt.label.miles_left" | translate).format([remainingBalance | formatNumber]) }}</span>
    </div>
    <air-miles-sticker *ngIf="receipt" [points]="receipt.total.points" [price]="receipt.total.price" [size]="'sm'"></air-miles-sticker>
  </div>
</div>
